import React from 'react';
import { BrainCircuit } from 'lucide-react';
export function RevelationSection() {
  return <section className="w-full py-20 px-4 bg-sage/5" data-id="element-69">
      <div className="max-w-2xl mx-auto" data-id="element-70">
        <div className="flex justify-center mb-6" data-id="element-71">
          <div className="p-3 bg-sage/10 rounded-full" data-id="element-72">
            <BrainCircuit className="w-8 h-8 text-sage" data-id="element-73" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown mb-10" data-id="element-74">
          El problema no es lo que estás comiendo.
        </h2>

        <div className="font-body text-lg md:text-xl text-brown leading-relaxed space-y-6" data-id="element-75">
          <p className="font-bold text-sage-dark" data-id="element-76">
            El problema es que tu Sistema Digestivo está "trabado" por culpa de
            la alerta constante en la que vivimos.
          </p>

          <p data-id="element-77">
            Cuando el cuerpo está estresado, apaga el{' '}
            <span className="font-bold text-terracotta" data-id="element-78">Nervio Vago</span>, el
            interruptor principal que le dice a tu estómago: "Ey, procesá la
            comida".
          </p>

          <p data-id="element-79">
            Si ese interruptor está apagado, la comida no se digiere, se
            fermenta. Por eso tenés gases, por eso estás hinchada y por eso
            vivís con esa "niebla mental" que no te deja pensar.
          </p>
        </div>
      </div>
    </section>;
}